module.exports = __webpack_public_path__ + "img/c782900ddfdbcc7f2183ea3f75215834.c782900d.png";